import { makeAutoObservable } from 'mobx'
import { type Integration } from 'entities/Integrations'
import type { IEntitiesStore } from 'entities/EntitiesExport'
import { IntegrationCollapseSettingsStore } from 'pages/settings/pages/integrations/pages/integrationSettings/store/IntegrationCollapseSettingsStore'
import { IntegrationTimelineStore } from 'pages/settings/pages/integrations/pages/integrationSettings/store/IntegrationTimelineStore'
import { IntegrationSettingsSyncStore } from 'pages/settings/pages/integrations/pages/integrationSettings/store/IntegrationSettingsSyncStore'
import { IntegrationCustomSettingsStore } from 'pages/settings/pages/integrations/pages/integrationSettings/store/IntegrationCustomSettingsStore'
import { INTERCOM_SYNC_CHECKBOX_KEYS } from 'pages/settings/pages/integrations/pages/integrationSettings/IntegrationIntercomSettings/lib'
import { type IIntercomSettingsDict } from 'pages/settings/pages/integrations/pages/integrationSettings/IntegrationIntercomSettings/types'
import { type IIntegrationStore } from 'pages/settings/pages/integrations/pages/integrationSettings/hooks/useIntegrationStoreMemo'
import { IntegrationIntercomConnectInboxStore } from './IntegrationIntercomConnectInboxStore'

export class IntegrationIntercomSettingsStore implements IIntegrationStore {
  private _collapseStore
  private _timelineStore
  private _customSettingsStore
  private _syncStore
  private _connectInboxStore

  constructor(integration: Integration, private _entities: IEntitiesStore) {
    this._collapseStore = new IntegrationCollapseSettingsStore()
    this._timelineStore = new IntegrationTimelineStore(this._entities, 'intercom', false)
    this._customSettingsStore = new IntegrationCustomSettingsStore<IIntercomSettingsDict>(
      integration,
      this._entities
    )
    this._syncStore = new IntegrationSettingsSyncStore(
      integration,
      this._customSettingsStore,
      INTERCOM_SYNC_CHECKBOX_KEYS
    )
    this._connectInboxStore = new IntegrationIntercomConnectInboxStore(integration, this._entities)

    makeAutoObservable(this)
  }

  init = () => {
    this._timelineStore.init()
    this._customSettingsStore.init1_0()
    this._syncStore.init()
    this._connectInboxStore.init()
  }

  dispose = () => {
    this._syncStore.dispose()
  }

  get syncStore() {
    return this._syncStore
  }

  get collapseStore() {
    return this._collapseStore
  }

  get timelineStore() {
    return this._timelineStore
  }

  get connectInboxStore() {
    return this._connectInboxStore
  }
}
